import { render, staticRenderFns } from "./superuser-my-account-container.vue?vue&type=template&id=ca9da72e&"
import script from "./superuser-my-account-container.vue?vue&type=script&lang=js&"
export * from "./superuser-my-account-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports